module.exports = __webpack_public_path__ + "img/benoit14.3e632bf7.jpg";